



















import Vue from "vue";
import { Computed, Data, Method, Props } from "./formQuestionsTypes";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-cancel-survey-form-questions",

  props: {
    questions: { default: [] },
    isShow: { default: true },
    parentQuestionId: { default: -1 },
    choiceId: { default: -1 }
  }
});
